import React, { useRef } from 'react';
import { Modal } from 'antd';
import { Box, Flex, Heading, Link, Paragraph } from 'theme-ui';
import { ParkPayload } from 'services/payloads/ParkPayload';

type Props = {
  park: ParkPayload
}
const BottomSection: React.FC<Props> = ({ park }) => {
  const policy = park?.policySetting;
  const ref = useRef<HTMLDivElement>(null);

  const openModal = (title: string, htmlText: string) => () => {
    const content = (<div ref={ref}></div>);
    Modal.info({ title, content, onOk: null });

    setTimeout(() => {
      ref.current.innerHTML = htmlText;
    }, 10);
  };

  const ModalText = ({ title, content }) => (
    <Link onClick={openModal(title, content)} sx={{userSelect: 'none'}}>{title}</Link>
  );

  return (
    <Box className="bottom-section" mx={[16, 16, 16, "auto"]} py={[32, 40]} sx={{maxWidth: 'container'}}>
      <Flex sx={{ flexDirection: ['column', 'column', 'row'], gap: 32 }}>
        <Box sx={{flex: 14}}>
          <Heading>Cancelation Policy</Heading>
          <Paragraph>
            We offer full refunds with a $10 service charge for all reservations canceled 72 hours prior to arrival date.
            Reservations canceled less than 72 hours before arrival will be charged the deposit amount equal to one night.
            <br />
            Campers who do not call or show up for their reservation will be canceled without a refund of their deposit.
            <br />
            No refunds due to weather or early departure.
          </Paragraph>
          <Box sx={{ lineHeight: 2, my: 4, fontSize: 1, fontWeight: 'bold' }}>
            <ModalText title="Cancellation Policy" content={policy?.cancellationPolicy} /><br />
            <ModalText title="Refund Policy" content={policy?.refundPolicy} /><br />
          </Box>
        </Box>
        <Box sx={{flex: 10}}>
          <Heading>Support</Heading>
          <Paragraph>
            Have a question? Our customer support team is here to help:<br/>
            <br/>
            Email: <Link href="mailto:info@madriverrv.com">info@madriverrv.com</Link><br/>
            Phone: <Link href="tel:(707) 822-7275">(707) 822-7275</Link><br/>
          </Paragraph>
        </Box>
      </Flex>
    </Box>
  );
}

export default BottomSection;
